import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import Sidebar from '../components/Sidebar'
import HeaderComponent from '../components/HeaderComponent'
import styled from 'styled-components'
import DashboardComponent from '../components/DashboardComponent'
import MediaComponent from '../components/MediaComponent'
import { firestore } from "../utils/firebase"
import EditComponent from '../components/EditComponent'
import UserComponent from '../components/UserComponent'
import AddEditorComponent from '../components/AddEditorComponent'
import { navigate } from 'gatsby'
import { onAuthStateChanged, signOut  } from 'firebase/auth';
import { auth } from '../utils/firebase'

const Dashboard = () => {
    const [tabs, setTabs] = useState('Dashboard')
    const [items, setItems] = useState([])
    const [users, setUsers] = useState([])
    const [newUsers, setNewUsers] = useState([])
    const [totalItems, setTotalItems] = useState(1)
    const [editData, setEditData] = useState({})
    const [cardItems, setCardItems] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [userSearchResults, setUserSearchResults] = useState([]);
    const [showDashboard, setShowDashboard] = useState(false);

    onAuthStateChanged(auth, (currentUser) => {
      if(currentUser){
        setShowDashboard(true)
      }else{
        typeof window !== 'undefined' && logout()
      }
  })
  const logout = async () => {
    await signOut(auth);
    navigate('/admin');
}
    useEffect(() => {
        const fetchItems = async() => {
          try{
            const itemsList = [];
            await firestore
            .collection('items')
            .orderBy('views', 'desc')
            .get()
            .then((querySnapshot) => {
              setTotalItems(querySnapshot.size)

            querySnapshot.forEach(doc => {
              const { title, embeddedCode, img, description, downloadUrl, imgName, views, downloads, category} = doc.data();
              itemsList.push({
                imgName,
            id : doc.id,
            img,
            embeddedCode,
            title,
            description,
            downloadUrl,
            views,
            downloads,
            category
    
              });
            })
            })
    
            setItems(itemsList);
    
          }catch(e){
            console.log(e);
          }
        }
        fetchItems();
        const fetchUsers = async() => {
          try{
            const usersList = [];
            await firestore
            .collection('users')
            .orderBy('totalUploads', 'desc')
            .get()
            .then((querySnapshot) => {

            querySnapshot.forEach(doc => {
              const { Name, Role, Email, Password, Mobile, Location, totalUploads, Img} = doc.data();
              usersList.push({
                Name,
                Role,
                Email,
                Password,
                Mobile,
                Location,
                totalUploads,
                Img
    
              });
            })
            })
    
            setUsers(usersList);
            setCardItems(usersList);
    
          }catch(e){
            console.log(e);
          }
        }
        fetchUsers();
        const fetchNewUsers = async() => {
          try{
            const usersNewList = [];
            await firestore
            .collection('users')
            .orderBy('createdAt', 'desc')
            .get()
            .then((querySnapshot) => {

            querySnapshot.forEach(doc => {
              const { Name, Role, Email, Password, Mobile, Location, totalUploads, Img} = doc.data();
              usersNewList.push({
                Name,
                Role,
                Email,
                Password,
                Mobile,
                Location,
                totalUploads,
                Img
                
    
              });
            })
            })
    
            setNewUsers(usersNewList);
    
          }catch(e){
            console.log(e);
          }
        }
        fetchNewUsers();
      }, [tabs]);
      
      useEffect(() => {
        const script = document.createElement("script");
      
          script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8941920110730602";
          script.async = true;
      
          document.body.appendChild(script);
      })
      const filterItem = (catItem) => {

        if(catItem === 'Top'){
         
          setCardItems(users);
          return;
        }
        else if(catItem === 'New'){
          setCardItems(newUsers);
          return;
        }
      }
      const searchHandler = (searchTerm) => {
        setSearchTerm(searchTerm)
        if(searchTerm !== "") {
          const filteredItems = items.filter((item) => {
           return item.title.toLowerCase().includes(searchTerm.toLowerCase())
          })
          setSearchResults(filteredItems)
        }else{
          setSearchResults(items)
        }
      }
      const userSearchHandler = (searchTerm) => {
        setUserSearchTerm(searchTerm)
        if(searchTerm !== "") {
          const filteredItems = users.filter((item) => {
           return item.Name.toLowerCase().includes(searchTerm.toLowerCase())
          })
          setUserSearchResults(filteredItems)
        }else{
          setUserSearchResults(users)
        }
      }
      if(showDashboard === false){
        return (
          <div></div>
        )
      }

    return (
        <Layout>
           <DashboardWrapper>
              <Sidebar setTabs={setTabs} />
              <HeaderComponent tabs={tabs} searchTerm={userSearchTerm} searchKeyword={userSearchHandler} logout={logout} />
              {
                  tabs === 'Dashboard'? <DashboardComponent /> : null
              }
              {
                  tabs === 'Media'? <MediaComponent itemData={searchTerm.length < 1 ? items : searchResults} totalItems={totalItems} tabs={tabs} setTabs={setTabs} setEditData={setEditData} searchTerm={searchTerm} searchKeyword={searchHandler} /> : null
              }
              {
                  tabs === 'Edit'? <EditComponent editData={editData} setTabs={setTabs} /> : null
              }
              {
                  tabs === 'Users'? <UserComponent filterItem={filterItem} usersData={userSearchTerm.length < 1 ? cardItems : userSearchResults} setTabs={setTabs}   /> : null
              }
              {
                  tabs === 'AddEditor'? <AddEditorComponent setTabs={setTabs} /> : null
              }
              

           </DashboardWrapper>
            
        </Layout>
    )
}

export default Dashboard

const DashboardWrapper = styled.div`
width: 100vw;
background-color: #FFFFFF;
`